import { forwardRef, type HTMLAttributes } from "react";
import { cn } from "@/lib/utils";

export interface RuleProps extends HTMLAttributes<HTMLHRElement> {
  weight?: "thin" | "double";
  /** Optional inset on both ends. Use sparingly; the editorial rule is full-bleed by default. */
  inset?: boolean;
}

export const Rule = forwardRef<HTMLHRElement, RuleProps>(function Rule(
  { weight = "thin", inset = false, className, ...rest },
  ref,
) {
  return (
    <hr
      ref={ref}
      className={cn(
        "border-0 w-full",
        weight === "double" ? "border-t-2 border-double border-rule" : "border-t border-rule",
        inset && "mx-auto max-w-[80%]",
        className,
      )}
      {...rest}
    />
  );
});
